import { gql } from 'apollo-boost';

const query = gql`
  query carrierBatchById($orgId: Int!) {
    carrier {
      onTimeStats(orgId: $orgId, summarize: false) {
        carrierId
        carrierName
        scac
        numPickedUp
        numDelivered
        numLateDeliveries
        numLatePickups
        percentOnTimeForPickup
        percentOnTimeForDelivery
        createdFromUtc
      }
    }
  }
`;

export const retrieveData = async (orgId, ApolloClient) => {
  const {
    data: {
      carrier: { onTimeStats }
    }
  } = await ApolloClient.query({
    query,
    variables: {
      orgId
    }
  });
  return onTimeStats;
};

export default { retrieveData };
